/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransitionDto } from './TransitionDto';
import {
    TransitionDtoFromJSON,
    TransitionDtoFromJSONTyped,
    TransitionDtoToJSON,
    TransitionDtoToJSONTyped,
} from './TransitionDto';

/**
 * Finding state transition audit history
 * @export
 * @interface FindingStateTransitionHistoryResponse
 */
export interface FindingStateTransitionHistoryResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FindingStateTransitionHistoryResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FindingStateTransitionHistoryResponse
     */
    instanceId?: string;
    /**
     * 
     * @type {Array<TransitionDto>}
     * @memberof FindingStateTransitionHistoryResponse
     */
    transitions?: Array<TransitionDto>;
}

/**
 * Check if a given object implements the FindingStateTransitionHistoryResponse interface.
 */
export function instanceOfFindingStateTransitionHistoryResponse(value: object): value is FindingStateTransitionHistoryResponse {
    return true;
}

export function FindingStateTransitionHistoryResponseFromJSON(json: any): FindingStateTransitionHistoryResponse {
    return FindingStateTransitionHistoryResponseFromJSONTyped(json, false);
}

export function FindingStateTransitionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingStateTransitionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'transitions': json['transitions'] == null ? undefined : ((json['transitions'] as Array<any>).map(TransitionDtoFromJSON)),
    };
}

export function FindingStateTransitionHistoryResponseToJSON(json: any): FindingStateTransitionHistoryResponse {
    return FindingStateTransitionHistoryResponseToJSONTyped(json, false);
}

export function FindingStateTransitionHistoryResponseToJSONTyped(value?: FindingStateTransitionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'instanceId': value['instanceId'],
        'transitions': value['transitions'] == null ? undefined : ((value['transitions'] as Array<any>).map(TransitionDtoToJSON)),
    };
}

